export function blocchi_valori_templates(){
    (function($) {
        let pageIdElement = document.getElementById('pagina_corrente_id');
        let windowSize = $(window).width();
        if(pageIdElement != null){
            let paginaCorrenteID = parseInt(document.getElementById('pagina_corrente_id').value);
            // Esegui la richiesta AJAX
            $.ajax({
                url: ajax_object.ajax_url, // La variabile ajax_url è fornita da WordPress
                type: 'post',
                data: {
                    action: 'blocchi_valori_templates',
                    pagina_corrente_id: paginaCorrenteID,
                    widowSize: windowSize
                },
                success: function(response) {
                    // Inserisci il contenuto della risposta nel tuo container desiderato
                    $('#valori_container').html(response);
                    $('#valori_carousel').owlCarousel({
                        loop:false,
                        margin:16,
                        nav:true,
                        responsive:{
                            0:{
                                items:1,
                                margin:0.
                            },
                            600:{
                                items:1,
                                margin:0,
                            },
                            1000:{
                                items:4,
                            }
                        }
                    })
                },
                error: function(error) {
                    console.log(error);
                }
            });
        }

    })(jQuery);
}